<template>
<v-app id="inspire">

<vue-header-admin></vue-header-admin>
<v-main>
    <v-container fluid class="px-6 py-6">
      <v-tabs
       class="mt-3 mb-3"
       color="#4CAF50"
                  left
                >
                  <v-tab>General</v-tab>
                  <v-tab>Letters</v-tab>
                  <v-tab>Products</v-tab>
                  <v-tab-item
                  style="background-color: transparent!important;"
                    :key="0"
                  >
        <v-row
            align="center"
            style="margin-bottom: 80px!important;"
            justify="center"
          >
            <v-col cols="12" md="12">
              <v-card class="card-shadow border-radius-xl mt-2" id="basic" style="margin-bottom: 100px;">
                <v-card-text style="margin-bottom: -30px;">
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                    <h5 class="text-h4 font-weight-bold text-typo">Company Settings</h5>
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                     <v-text-field
                        id="name"
                        name="name"
                        class="font-size-input input-style"
                        label="Company Name"
                        width="300px"
                        ref="name"
                        v-model="company.name"
                        />

                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                     <v-text-field
                        id="name"
                        name="name"
                        class="font-size-input input-style"
                        label="Contact Email"
                        width="300px"
                        ref="name"
                        v-model="company.contact_email"
                        />

                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                     <v-text-field
                        id="name"
                        name="name"
                        class="font-size-input input-style"
                        label="Contact Phone"
                        v-mask="'(###) ###-####'"
                        width="300px"
                        ref="name"
                        v-model="company.contact_phone"
                        />

                    </v-col>
                     <v-col
                      cols="12"
                      md="6"
                    >
                     <v-text-field
                        id="name"
                        name="name"
                        label="Full Name"
                        class="font-size-input input-style"
                        width="300px"
                        ref="name"
                        v-model="company.details"
                        />

                    </v-col>
                    <v-col cols="12"  sm="6" md="6" lg="6" style="margin-top:-35px;" >
                          <vuetify-google-autocomplete
                                  id="map"
                                  label="Address"
                                  v-model="company.address_1"
                                  placeholder="Enter a location"
                                  class="font-size-input input-style"
                                  v-on:placechanged="getAddressData"
                                  country="us"
                              ></vuetify-google-autocomplete>
                      </v-col>
                      <v-col cols="12"  sm="6" md="6" lg="6" style="margin-top:-35px;" >
                          <v-text-field
                          label="City"
                          v-model="company.city"
                          class="font-size-input input-style"
                    ></v-text-field>
                      </v-col>
                      <v-col cols="12"  sm="6" md="6" lg="6" style="margin-top:-35px;" >
                          <v-select
                          label="State"
                          :items="stateOptions"
                          item-text="name"
                          item-value="abbreviation"
                          placeholder="Select State"
                          v-model="company.state"
                          class="font-size-input input-style"
                    ></v-select>
                      </v-col>
                      <v-col cols="12"  sm="6" md="6" lg="6" style="margin-top:-35px;" >
                          <v-text-field
                          label="Zip"
                          v-model="company.zip"
                          class="font-size-input input-style"
                    ></v-text-field>
                      </v-col>
                      <v-col cols="12"  sm="6" md="6" lg="6" style="margin-top:-35px;" >
                          <v-text-field
                          label="What is the cost of Consultation and document preparation (For Complex Cases)?"
                          v-model="company.question_1"
                          class="font-size-input input-style"
                    ></v-text-field>
                      </v-col>
                      <v-col cols="12"  sm="6" md="6" lg="6" style="margin-top:-35px;" >
                          <v-text-field
                          label="What is the cost of Consultation and document preparation?"
                          v-model="company.question_2"
                          class="font-size-input input-style"
                    ></v-text-field>
                      </v-col>
                      <v-col cols="12"  sm="6" md="6" lg="6" style="margin-top:-35px;" >
                          <v-text-field
                          label="What is the your monthly cost to client? (Expect to pay up to 6 Months)"
                          v-model="company.question_3"
                          class="font-size-input input-style"
                    ></v-text-field>
                      </v-col>
                      <v-col cols="12"  sm="6" md="6" lg="6" style="margin-top:-35px;" >
                          <v-text-field
                          label="What is Client Required to pay for monitoring monthly?"
                          v-model="company.question_4"
                          class="font-size-input input-style"
                    ></v-text-field>
                      </v-col>
                      <v-col cols="12"  sm="12" md="12" lg="12" style="margin-top:-35px;" >
                          <v-text-field
                          label="Other Fees?"
                          v-model="company.question_5"
                          class="font-size-input input-style"
                    ></v-text-field>
                      </v-col>
                      <v-col
                      cols="12"
                      md="12"
                    >
                    
                    <!-- <html-editor height=500 v-model="company.privacy_template"></html-editor> -->
                    <editor
                        v-model="company.privacy_template"
                        api-key="gy0tehv0d7n934gbood5c6jyemezfrywnh9b6p5keila4odp"
                        :init="{
                          height: 500,
                          menubar: true,
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount'
                          ],
                          toolbar:
                            'undo redo | formatselect | bold italic backcolor | \
                            alignleft aligncenter alignright alignjustify | \
                            bullist numlist outdent indent | removeformat | help'
                        }"
                      />
                      <v-btn
                      dark
                    color="purple"
                    class="float-right ml-2 mt-2"
                    @click="company.privacy_template = default_template"
                  >Copy Default Template</v-btn>
                    
                    </v-col>



                       <v-col
                    cols="12"
                    md="6"
                    >
                    <label for="my-file">Company Logo</label>
                   <input type="file" accept="image/*" @change="previewImage" class="form-control-file" id="my-file">
                   <div class="border p-2 mt-3">
                      <p>Preview Here:</p>
                      <template v-if="preview">
                        <v-img contain :src="preview" class="img-fluid" />
                      </template>
                    </div>
                    <v-btn
                      dark
                    color="purple"
                    class="float-right ml-2 mt-2"
                    @click="openResize = true"
                  >Resize Logo</v-btn>
                   <v-btn
                      dark
                    color="red"
                    class="float-right ml-2 mt-2"
                    @click="removeLogo"
                  >Remove Logo</v-btn>
                     <v-btn
                      dark
                    color="primary"
                    class="float-right mt-2"
                    @click="uploadLogo"
                  >Upload</v-btn>
                    
                    </v-col>
                    <v-col
                    cols="12"
                    md="6"
                    >
                    <label for="my-file">Company Background</label>
                   <input type="file" accept="image/*" @change="previewImageBG" class="form-control-file" id="my-file-bg">
                   <div class="border p-2 mt-3">
                      <p>Preview Here:</p>
                      <template v-if="previewbg">
                        <v-img contain :src="previewbg" class="img-fluid" />
                      </template>
                    </div>
                    <v-btn
                      dark
                    color="purple"
                    class="float-right ml-2 mt-2"
                    @click="openResize = true"
                  >Resize Logo</v-btn>
                   <v-btn
                      dark
                    color="red"
                    class="float-right ml-2 mt-2"
                    @click="removeLogoBG"
                  >Remove Logo</v-btn>
                     <v-btn
                      dark
                    color="primary"
                    class="float-right mt-2"
                    @click="uploadLogoBG"
                  >Upload</v-btn>
                    
                    </v-col>
                    <v-col
                    cols="12"
                    md="12"
                    >
                    <v-card-actions class="justify-center">
                  <v-btn
                      dark
                      large
                    color="grey"
                    class="
                          font-weight-bolder
                          btn-default
                          mb-5
                          px-8
                          justify-center
                        "
                    @click="$router.push({ name: 'Dashboard' })"
                  >Back</v-btn>
                   <v-btn
                      dark
                      large
                    color="green"
                    class="
                          font-weight-bolder
                          btn-default
                          mb-5
                          px-8
                          justify-center
                        "
                    @click="saveProfile"
                  >Save</v-btn>
                </v-card-actions>
                    </v-col>

                    
                  </v-row>
                </v-card-text>
                <!-- <v-card-actions class="justify-center ">
                  <v-btn
                    tile  dark
                    style="height: 49px;width:95px;"
                    color="primary"
                    class="mb-10"
                    @click="saveProfile"
                  >Save</v-btn>
                </v-card-actions> -->
              </v-card>
            </v-col>
          </v-row>
          </v-tab-item>
          <v-tab-item
                  style="background-color: transparent!important;"
                    :key="1"
                  >
                  <v-row
            align="center"
            justify="center"
            class="mt-10 mb-5"
          >
            <v-col cols="12" md="12">
              <v-card class="card-shadow border-radius-xl mt-2" id="basic">
                <v-card-text style="margin-bottom: -30px;" >
                  <v-row>
                      
                    <v-col
                      cols="12"
                      md="12"
                    >
                    <!-- <h1 class="text-center mt-5 mb-5">Company Settings</h1> -->
                    <h5 class="text-h4 font-weight-bold text-typo">Letters({{totalCountLetter}})</h5>
                    </v-col>
                    <v-col cols="12"
                      md="12" >
                         <v-btn
                                    color="#4CAF50"
                        class="
                         ont-weight-bolder
                          btn-default
                          py-4
                          px-8
                          ms-auto
                          mt-sm-auto mt-4
                                        
                                      "
                                        small
                                        style="float: left;"
                                        @click="$router.push('add-letter')"
                                    >
                                        Create New Letter
                                    </v-btn>
                      </v-col>
                    <v-col cols="12"
                      md="12">
                      
                        <v-data-table
                            :headers="headers_letter"
                            :options.sync="datatable_options_letter"
                            :items="letters"
                            loading-text="Loading... Please wait"
                            :page.sync="page_letter"
                            :items-per-page="itemsPerPage_letter"
                            hide-default-footer
                            class="table"
                        >
                     
                        <template v-slot:item.is_iframe="{ item }">
                            {{item.is_iframe == 1 ? 'Iframe' :'New Tab'}}
                        </template>
                        <template v-slot:item.email="{ item }">
                            {{item.email ? item.email : 'Not Available'}}
                        </template>
                         <template v-slot:item.phone="{ item }">
                            {{item.phone_m ? item.phone_m : "Not Avilable"}}
                        </template>
                        <template v-slot:item.date_of_birth="{ item }">
                            {{dateFormat(item.dob)}}
                        </template>
                        <template v-slot:item.price="{ item }">
                            {{'$'+item.price}}
                        </template>
                        <template v-slot:item.title="{ item }" >
                           <span style="cursor:pointer;color:blue;" @click="$router.push('edit-letter/'+item.id)"> {{item.title}} </span>
                        </template>
                        <template v-slot:item.status="{ item }">
                            {{item.status == 1 ? 'Active' :'Inactive'}}
                        </template>
                        <template v-slot:item.edit="{ item }">
                             <v-btn
                            class="mx-2"
                            text
                            dark
                           @click="openEdit(item)"
                            x-small
                            color="blue"
                          >
                            <v-icon size="20" class="material-icons-round opacity-10" dark>
                              edit
                            </v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.password="{ item }">
                             <v-btn
                            class="mx-2"
                            fab
                            dark
                            @click="dialogDetail = true,selectedItem = item"
                            x-small
                            color="green"
                          >
                            {{item.total_count}}
                          </v-btn>
                        </template>
                      
                        <template v-slot:item.address="{ item }">
                        <span ><span v-if="item.address_1">{{ item.address_1 }}</span>
                        </span>
                        </template>
                        <template v-slot:item.status_id="{ item }">
                           <v-btn
                            class="mx-2"
                            dark
                            @click="changeStatus(item.user_id,item.status)"
                            x-small
                            :color="item.status==1 ? 'red':'green'"
                          >
                          {{item.status==1 ? 'Deactivate':'Activate'}}
                          </v-btn>
                        </template>
                        <template v-slot:item.document="{ item }">
                          {{item.is_uploaded_doc == 1 ? 'Available' : 'Not available'}}
                        </template>
                          <template v-slot:item.edit="{ item }">
                             <v-btn
                            class="mx-2"
                            text
                            dark
                           @click="$router.push('edit-letter/'+item.id)"
                            x-small
                            color="blue"
                          >
                            <v-icon size="20" class="material-icons-round opacity-10" dark>
                              edit
                            </v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.id="{ item }">

                          <v-btn
                            class="mx-2"
                            text
                            dark
                            @click="deleteItemLetter(item.id)"
                            x-small
                            color="red"
                          >
                           <v-icon size="20" class="material-icons-round opacity-10" dark>
                              delete
                            </v-icon>
                          </v-btn>
                        </template>
                        </v-data-table>
                        <div class="text-center pt-2">
                            <v-pagination
                            circle
                            prev-icon="fa fa-angle-left"
                            next-icon="fa fa-angle-right"
                            class="pagination"
                            color="#4CAF50"
                                v-model="page_letter"
                                :length="pageCountLetter"
                                @input="getLetters"
                            ></v-pagination>
                            </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          </v-tab-item>



          <v-tab-item
                  style="background-color: transparent!important;"
                    :key="1"
                  >
                  <v-row
            align="center"
            justify="center"
            class="mt-10 mb-5"
          >
            <v-col cols="12" md="12">
              <v-card class="card-shadow border-radius-xl mt-2" id="basic">
                <v-card-text style="margin-bottom: -30px;" >
                  <v-row>
                      
                    <v-col
                      cols="12"
                      md="12"
                    >
                    <!-- <h1 class="text-center mt-5 mb-5">Company Settings</h1> -->
                    <h5 class="text-h4 font-weight-bold text-typo">Products({{totalCount}})</h5>
                    </v-col>
                      <v-col cols="12"
                      md="12" >
                      <v-btn
                        elevation="0"
                        @click="dialogAssign = true"
                        :ripple="false"
                        small
                        style="float: left;margin-right:15px;"
                        color="#4CAF50"
                        class="
                         ont-weight-bolder
                          btn-default
                          py-4
                          px-8
                          ms-auto
                          mt-sm-auto mt-4
                                        
                                      "
                        >Add Product </v-btn
                      >
                      <v-btn
                        @click="$router.push('/admin/preview-products')"
                        small
                        color="blue"
                        class="
                         ont-weight-bolder
                          btn-default
                          py-4
                          px-8
                          ms-auto
                          mt-sm-auto mt-4
                                        
                                      "
                        >Preview </v-btn
                      >
                      </v-col>
                    <v-col cols="12"
                      md="12">
                      <v-data-table
                            :headers="headers_jobs"
                            :options.sync="datatable_options"
                            :items="users"
                            class="table"
                            loading-text="Loading... Please wait"
                            :page.sync="page"
                            v-sortable-data-table
                            @sorted="saveOrder"
                            :items-per-page="itemsPerPage"
                            :footer-props="{
                                    firstIcon: '',
                                    lastIcon: '',
                                    prevIcon: '',
                                    nextIcon: '',
                                    'page-text': false,
                                    'items-per-page-options': [-1]
                                  }"
  
                        >
                     
                        <template v-slot:item.status="{ item }">
                            {{item.status == 1 ? 'Active' :'Inactive'}}
                        </template>
                        <template v-slot:item.email="{ item }">
                            {{item.email ? item.email : 'Not Available'}}
                        </template>
                         <template v-slot:item.phone="{ item }">
                            {{item.phone_m ? item.phone_m : "Not Avilable"}}
                        </template>
                        <template v-slot:item.date_of_birth="{ item }">
                            {{dateFormat(item.dob)}}
                        </template>
                        <template v-slot:item.price="{ item }">
                            {{'$'+item.price}}
                        </template>
                         <template v-slot:item.edit="{ item }">
                             <v-btn
                            class="mx-2"
                            text
                            dark
                           @click="productEditOpen(item)"
                            x-small
                            color="blue"
                          >
                            <v-icon class="material-icons-round opacity-10"  size="20" dark>
                              edit
                            </v-icon>
                          </v-btn>
                        </template>
                        <template v-slot:item.password="{ item }">
                             <v-btn
                            class="mx-2"
                            fab
                            dark
                            @click="dialogDetail = true,selectedItem = item"
                            x-small
                            color="green"
                          >
                            {{item.total_count}}
                          </v-btn>
                        </template>
                      
                        <template v-slot:item.address="{ item }">
                        <span ><span v-if="item.address_1">{{ item.address_1 }}</span>
                        </span>
                        </template>
                        <template v-slot:item.status_id="{ item }">
                           <v-btn
                            class="mx-2"
                            dark
                            @click="changeStatus(item.user_id,item.status)"
                            x-small
                            :color="item.status==1 ? 'red':'green'"
                          >
                          {{item.status==1 ? 'Deactivate':'Activate'}}
                          </v-btn>
                        </template>
                        <template v-slot:item.document="{ item }">
                          {{item.is_uploaded_doc == 1 ? 'Available' : 'Not available'}}
                        </template>
                       
                        <template v-slot:item.id="{ item }">

                          <v-btn
                            class="mx-2"
                            text
                            dark
                            @click="deleteItem(item.id)"
                            x-small
                            color="red"
                          >
                            <v-icon size="20" class="material-icons-round opacity-10" dark>
                              delete
                            </v-icon>
                          </v-btn>
                        </template>
                        </v-data-table>


                      </v-col>
                      </v-row>
                      </v-card-text>
                      </v-card>
                      </v-col>
                      </v-row>
                      </v-tab-item>
          </v-tabs>
          <v-dialog
        fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      v-model="openResize"
    >

     <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="openResize = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Resize Logo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>

          </v-toolbar-items>
        </v-toolbar>
        <div>
               <iframe
                                id="JotFormIFrame-90142788412154"
                                title="Trainee Registration Form"
                                onload="window.parent.scrollTo(0,0)"
                                allowtransparency="true"
                                allowfullscreen="true"
                                allow="geolocation; microphone; camera"
                                src="https://www.countingcharacters.com/image-resizer-online#sectionbg"
                                frameborder="0"
                                style="width: 1px;
                                min-width: 100%;
                                height:1000px;
                                border:none;"
                                scrolling="yes"
                                ></iframe>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
        persistent
      v-model="dialogAssign"
      width="500"
    >

      <v-card>
        <v-card-title class="text-h5 grey lighten-2" v-if="!product.id">
          Add new Product
        </v-card-title>
        <v-card-title class="text-h5 grey lighten-2" v-else>
          Edit Product
        </v-card-title>
        <v-card-text style="margin-top:30px;"> 
          <v-text-field
                label="Credit"
                v-model="product.credit"
                v-mask="'###########################'"
          ></v-text-field>
          <v-text-field
                v-model="product.price"
                label="Price"
                prefix="$"
                v-mask="'###########################'"
          ></v-text-field>
              <!-- <v-select
              label="Type"
            v-model="product.type"
            :items="['Company','Client']"
          ></v-select> -->
          <v-text-field
                v-model="product.name"
                label="Name"
          ></v-text-field>
          <v-col cols="12">
                     <v-data-table
                          :headers="headers_basic"
                          :items="product.items"
                          sort-by="calories"
                          class="table mb-10"
                        >
                          <template v-slot:top>
                            <v-toolbar
                              flat
                            >
                              <v-toolbar-title>Items</v-toolbar-title>
                              <v-divider
                                class="mx-4"
                                inset
                                vertical
                              ></v-divider>
                              <v-spacer></v-spacer>
                              <v-btn
                                    color="blue"
                                    dark
                                    @click="dialog_basic = true,selected_item = 'plan1'"
                                    class="mb-2"
                                  >
                                    New Item
                                  </v-btn>
                            </v-toolbar>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-icon
                              small
                              class="material-icons-round mr-2"
                              @click="editItemBasic('plan1',item)"
                            >
                              edit
                            </v-icon>
                            <v-icon
                              small
                              class="material-icons-round"
                              @click="deleteItemBasic('plan1',item)"
                            >
                              delete
                            </v-icon>
                          </template>
                        </v-data-table>
                   </v-col>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          v-if="!product.id"
            color="#4caf50"
            text
            :disabled="loadingAssign"
            @click="addPromo()"
          >
            Submit
          </v-btn><v-btn
          v-else
            color="primary"
            text
            :disabled="loadingAssign"
            @click="editPromo()"
          >
            Submit
          </v-btn>
           <v-btn
            color="primary"
            text
            :disabled="loadingAssign"
            @click="dialogAssign = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteBasic" max-width="500px">
                                <v-card>
                                  <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="blue darken-1" text @click="closeDeleteBasic">Cancel</v-btn>
                                    <v-btn color="blue darken-1" text @click="deleteItemConfirmBasic(selected_item)">OK</v-btn>
                                    <v-spacer></v-spacer>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
    <v-dialog
                                v-model="dialog_basic"
                                max-width="500px"
                              >
                                <v-card>
                                  <v-card-title>
                                    <span class="text-h5">{{ formTitle }}</span>
                                  </v-card-title>

                                  <v-card-text>
                                    <v-container>
                                      <v-row>
                                        <v-col
                                          cols="12"
                                          sm="12"
                                          md="12"
                                        >
                                          <v-text-field
                                            v-model="editedItemBasic.item"
                                            label="Enter Item"
                                          ></v-text-field>
                                        </v-col>
                                        
                                      </v-row>
                                    </v-container>
                                  </v-card-text>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="closeBasic"
                                    >
                                      Cancel
                                    </v-btn>
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="saveBasic(selected_item)"
                                    >
                                      Save
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
    </v-container>
    
     <!-- <vue-footer></vue-footer> -->
     </v-main>
</v-app>

</template>

<script>
import { VueTelInput } from 'vue-tel-input'
import HtmlEditor from "../HtmlEditor.vue";
import Editor from '@tinymce/tinymce-vue'
import Sortable from 'sortablejs';
export default {
components: {
      VueTelInput, HtmlEditor,'editor': Editor
  },
  data () {

      return {
        fname : '',
        lname : '',
        email : '',
        name:'',
        phone:'',
        password : '',
        is_admin:0,
        confpassword : '',
        logoutOtherDevices: false,
        dialogDeleteBasic: false,
        openResize: false,
        role : '',
        companyname : '',
        sector : '',
        no_of_employee : '',
        limit_letter: 10,
        showPassword : false,
        page_letter : 1,
        itemsPerPage_letter: 10,
        datatable_options: {},
        pageCountLetter : 1,
        letters : [],
        formTitle : '',
        dialog_basic : false,
        datatable_options_letter : {},
        users : [],
        totalCountLetter : 0,
        totalCount : 0,
        loadingAssign : false,
        page : 1,
        headers_basic: [
          { text: 'Item', value: 'item' },
          { text: 'Actions', value: 'actions', sortable: false },
        ],
        headers_jobs: [
          { text: 'Price', value: 'price',
            sortable: true },
          { text: 'Credit', value: 'credit',
            sortable: true },
          // { text: 'Type', value: 'type',
          //   sortable: true },
          { text: 'Created at', value: 'created_at',
            sortable: true,width: '200' },
          { text: 'Updated at', value: 'updated_at',
            sortable: true,width: '200' },
            { text: 'Edit', value: 'edit',
            sortable: false },
          { text: 'Delete', value: 'id',
            sortable: false,width: '50' },
        ],
        itemsPerPage : 10,
        product: {
          credit: 0,
          price: 0,
          type :'Client',
          items : [],
          name : ''
        },
        editedItemBasic: {
          item: '',
        },
        dialogAssign : false,
        phoneFlag:0,
        headers_letter : [
           { text: 'Title', value: 'title',
            sortable: true },
          { text: 'Category', value: 'category',
            sortable: true },
          { text: 'Staus', value: 'status',
            sortable: true },
          { text: 'Created at', value: 'created_at',
            sortable: true,width: '200' },
          { text: 'Updated at', value: 'updated_at',
            sortable: true,width: '200' },
            { text: 'Edit', value: 'edit',
            sortable: true,width: '200' },
          { text: 'Delete', value: 'id',
            sortable: false,width: '50' },
        ],
        emailFlag:0,
        preview: null,
      image: null,
        country :'',
        otp_email:'',
        otp_phone:'',
        stateOptions: [
                { name: 'ALABAMA', abbreviation: 'AL'},
                { name: 'ALASKA', abbreviation: 'AK'},
                { name: 'AMERICAN SAMOA', abbreviation: 'AS'},
                { name: 'ARIZONA', abbreviation: 'AZ'},
                { name: 'ARKANSAS', abbreviation: 'AR'},
                { name: 'CALIFORNIA', abbreviation: 'CA'},
                { name: 'COLORADO', abbreviation: 'CO'},
                { name: 'CONNECTICUT', abbreviation: 'CT'},
                { name: 'DELAWARE', abbreviation: 'DE'},
                { name: 'DISTRICT OF COLUMBIA', abbreviation: 'DC'},
                { name: 'FEDERATED STATES OF MICRONESIA', abbreviation: 'FM'},
                { name: 'FLORIDA', abbreviation: 'FL'},
                { name: 'GEORGIA', abbreviation: 'GA'},
                { name: 'GUAM', abbreviation: 'GU'},
                { name: 'HAWAII', abbreviation: 'HI'},
                { name: 'IDAHO', abbreviation: 'ID'},
                { name: 'ILLINOIS', abbreviation: 'IL'},
                { name: 'INDIANA', abbreviation: 'IN'},
                { name: 'IOWA', abbreviation: 'IA'},
                { name: 'KANSAS', abbreviation: 'KS'},
                { name: 'KENTUCKY', abbreviation: 'KY'},
                { name: 'LOUISIANA', abbreviation: 'LA'},
                { name: 'MAINE', abbreviation: 'ME'},
                { name: 'MARSHALL ISLANDS', abbreviation: 'MH'},
                { name: 'MARYLAND', abbreviation: 'MD'},
                { name: 'MASSACHUSETTS', abbreviation: 'MA'},
                { name: 'MICHIGAN', abbreviation: 'MI'},
                { name: 'MINNESOTA', abbreviation: 'MN'},
                { name: 'MISSISSIPPI', abbreviation: 'MS'},
                { name: 'MISSOURI', abbreviation: 'MO'},
                { name: 'MONTANA', abbreviation: 'MT'},
                { name: 'NEBRASKA', abbreviation: 'NE'},
                { name: 'NEVADA', abbreviation: 'NV'},
                { name: 'NEW HAMPSHIRE', abbreviation: 'NH'},
                { name: 'NEW JERSEY', abbreviation: 'NJ'},
                { name: 'NEW MEXICO', abbreviation: 'NM'},
                { name: 'NEW YORK', abbreviation: 'NY'},
                { name: 'NORTH CAROLINA', abbreviation: 'NC'},
                { name: 'NORTH DAKOTA', abbreviation: 'ND'},
                { name: 'NORTHERN MARIANA ISLANDS', abbreviation: 'MP'},
                { name: 'OHIO', abbreviation: 'OH'},
                { name: 'OKLAHOMA', abbreviation: 'OK'},
                { name: 'OREGON', abbreviation: 'OR'},
                { name: 'PALAU', abbreviation: 'PW'},
                { name: 'PENNSYLVANIA', abbreviation: 'PA'},
                { name: 'PUERTO RICO', abbreviation: 'PR'},
                { name: 'RHODE ISLAND', abbreviation: 'RI'},
                { name: 'SOUTH CAROLINA', abbreviation: 'SC'},
                { name: 'SOUTH DAKOTA', abbreviation: 'SD'},
                { name: 'TENNESSEE', abbreviation: 'TN'},
                { name: 'TEXAS', abbreviation: 'TX'},
                { name: 'UTAH', abbreviation: 'UT'},
                { name: 'VERMONT', abbreviation: 'VT'},
                { name: 'VIRGIN ISLANDS', abbreviation: 'VI'},
                { name: 'VIRGINIA', abbreviation: 'VA'},
                { name: 'WASHINGTON', abbreviation: 'WA'},
                { name: 'WEST VIRGINIA', abbreviation: 'WV'},
                { name: 'WISCONSIN', abbreviation: 'WI'},
                { name: 'WYOMING', abbreviation: 'WY' }
            ],
        company : {
          name: "",
          contact_email: "",
          contact_phone: "",
          details:"",
          email: "",
          password: "",
          password_confirmation: "",
          address: '',
          city: '',
          state: '',
          zip:'',
          question_1 : '',
          question_2 : '',
          question_3 : '',
          question_4 : '',
          question_5 : '',
          logo : '',
          backgroung_logo : '',
          privacy_template : '',
          

        },
        default_template : `<p>&nbsp;</p>
<div id="__nuxt">
<div>
<div class="bgCover bg-fixed">&nbsp;</div>
<!--[-->
<div>
<div>
<div id="nav-menu-popup" class="hide" style="display: none;">
<div class="nav-menu-body">
<ul class="nav-menu"><!--[--><!--]--></ul>
</div>
</div>
</div>
<div id="overlay" class="hide" style="display: none; background-color: rgba(0, 0, 0, 0.5);"></div>
<div id="preview-container" class="preview-container hl_page-preview--content">
<div data-v-0bad29cf=""><!--[--><!--[-->
<div id="section-vBbNog7qm" class="fullSection none noBorder radius0 none c-section c-wrapper section-vBbNog7qm" data-v-0bad29cf="">
<div class="inner" data-v-0bad29cf=""><!--[--><!--[-->
<div id="row-rMZ02OgOgw" class="row-align-center none noBorder radius0 none c-row c-wrapper row-rMZ02OgOgw" data-v-0bad29cf="">
<div class="inner" data-v-0bad29cf=""><!--[--><!--[-->
<div id="col-XpfmHWfw04" class="c-column c-wrapper col-XpfmHWfw04" data-v-0bad29cf="">
<div class="none noBorder radius0 none bg bgCover vertical inner" data-v-0bad29cf=""><!--[--><!--[-->
<div id="heading-OS0Z2LcqUu" class="c-heading c-wrapper" data-v-0bad29cf="">
<div class="heading-OS0Z2LcqUu text-output cheading-OS0Z2LcqUu none noBorder radius0 none">
<div>
<h1><strong>TERMS AND CONDITIONS</strong></h1>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="divider-gC6AJZLS0" class="c-divider c-wrapper divider-gC6AJZLS0" data-v-0bad29cf="">
<div id="divider-gC6AJZLS0" class="divider-element cdivider-gC6AJZLS0"></div>
</div>
<!--]--><!--]--></div>
</div>
<!--]--><!--]--></div>
</div>
<!--]--><!--[-->
<div id="row-MslS67eTG3" class="row-align-center none noBorder radius0 none c-row c-wrapper row-MslS67eTG3" data-v-0bad29cf="">
<div class="inner" data-v-0bad29cf=""><!--[--><!--[-->
<div id="col-rtGjwWF9Mb" class="c-column c-wrapper col-rtGjwWF9Mb" data-v-0bad29cf="">
<div class="none noBorder radius0 none bg bgCover vertical inner" data-v-0bad29cf=""><!--[--><!--[-->
<div id="heading-MnPTHJF6HW" class="c-heading c-wrapper" data-v-0bad29cf="">
<div class="heading-MnPTHJF6HW text-output cheading-MnPTHJF6HW none noBorder radius0 none">
<div>
<p><strong><u>Last Revised: March 27, 2022</u></strong></p>
<h1>&nbsp;</h1>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="heading-4NMhoydBW" class="c-heading c-wrapper" data-v-0bad29cf="">
<div class="heading-4NMhoydBW text-output cheading-4NMhoydBW none noBorder radius0 none">
<div>
<h1><strong>E-SIGN, the Electronic Signatures in Global and National Commerce Act (15 U.S.C. &sect; 7001, et seq.), requires that you consent to entering into an electronic agreement with us before an online version of our software Please read the following information carefully.</strong></h1>
<p>&nbsp;</p>
<p><strong>Should you enter into an online Member Agreement (&ldquo;the Agreement&rdquo;), you will not be required to submit a paper application. The entire agreement between you and us will be evidenced by an electronic record. To enter into the Agreement, you must additionally electronically acknowledge that you agree to the Agreement Terms and Conditions, and the General Service Agreement. To access these documents and enter into the Agreement, you will need the following hardware and software: A Personal Computer (&ldquo;PC&rdquo;) with a modem or other Internet access device, operational Internet browser software (e.g., Mozilla Firefox, Google Chrome, Safari, or Internet Explorer), and Adobe Acrobat Reader. Should there ever be a change in the equipment or software necessary to access the terms of the Agreement, we will advise you of the same and will provide you with a list of the equipment and software that is necessary. Upon such an event, you may withdraw your consent.</strong></p>
</div>
</div>
</div>
<!--]--><!--]--></div>
</div>
<!--]--><!--]--></div>
</div>
<!--]--><!--[-->
<div id="row-Fbj37cn7-I" class="row-align-center none noBorder radius0 none c-row c-wrapper row-Fbj37cn7-I" data-v-0bad29cf="">
<div class="inner" data-v-0bad29cf=""><!--[--><!--[-->
<div id="col-eFRSEzZQz" class="c-column c-wrapper col-eFRSEzZQz" data-v-0bad29cf="">
<div class="none noBorder radius0 none bg bgCover vertical inner" data-v-0bad29cf=""><!--[--><!--[-->
<div id="heading-3KhsG4GtC" class="c-heading c-wrapper" data-v-0bad29cf="">
<div class="heading-3KhsG4GtC text-output cheading-3KhsG4GtC none noBorder radius0 none">
<div>
<h1><strong>General Service Agreement</strong></h1>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="heading-9YJcrbxU_" class="c-heading c-wrapper" data-v-0bad29cf="">
<div class="heading-9YJcrbxU_ text-output cheading-9YJcrbxU_ none noBorder radius0 none">
<div>
<p>This <strong>General Service Agreement</strong> (the "Agreement") is in full agreement with YOU. When YOU agree and sign, we mach your date and time stap with this aggrent.</p>
<p>&nbsp;</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-5d21GLi8k" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-5d21GLi8k text-output csub-heading-5d21GLi8k none noBorder radius0 none">
<div>
<h2><strong>BACKGROUND</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-adDn1WpnH" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-adDn1WpnH text-output cparagraph-adDn1WpnH none noBorder radius0 none">
<div>
<p><strong>A.</strong> The Client is of the opinion that the Contractor has the necessary qualifications, experience, and abilities to provide services to the Client.</p>
<p>&nbsp;</p>
<p><strong>B.</strong> The Contractor is agreeable to providing such services to the Client on the terms and conditions set out in this Agreement.</p>
<p>&nbsp;</p>
<p><strong>IN CONSIDERATION OF</strong> the matters described above and of the mutual benefits and obligations set forth in this Agreement, the receipt and sufficiency of which consideration is hereby acknowledged, the Client and the Contractor (individually the "Party" and collectively the "Parties" to this Agreement) agree as follows:</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-J8hadJfNU" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-J8hadJfNU text-output csub-heading-J8hadJfNU none noBorder radius0 none">
<div>
<h2><strong>SERVICES PROVIDED</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-PJG3Kavyp" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-PJG3Kavyp text-output cparagraph-PJG3Kavyp none noBorder radius0 none">
<div>
<p><strong>1</strong>. The client hereby agrees to engage the contractor to provide the client with the following services (the "Services"):</p>
<ul>
<li><strong>Grant Writing Services.</strong></li>
<li><strong>Grant Portal to track your grants</strong></li>
</ul>
<p>&nbsp;</p>
<p><strong>2.</strong> The Services will also include any other tasks which the Parties may agree on. The Contractor hereby agrees to provide such Services to the Client.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-oBJiXdJ8e" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-oBJiXdJ8e text-output csub-heading-oBJiXdJ8e none noBorder radius0 none">
<div>
<h2><strong>TERM OF AGREEMENT</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-DK5xA7dFi" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-DK5xA7dFi text-output cparagraph-DK5xA7dFi none noBorder radius0 none">
<div>
<p><strong>3.</strong> The term of this Agreement (the "Term") will begin on the date of this Agreement and will remain in full force and effect until the completion of the Services, subject to earlier termination as provided in this Agreement. The Term may be extended with the written consent of the Parties.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-wWXsgrbi6" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-wWXsgrbi6 text-output csub-heading-wWXsgrbi6 none noBorder radius0 none">
<div>
<h2><strong>PERFORMANCE</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-78PcXc7yi" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-78PcXc7yi text-output cparagraph-78PcXc7yi none noBorder radius0 none">
<div>
<p><strong>4. </strong>The Parties agree to do everything necessary to ensure that the terms of this Agreement take effect.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-c6O7nzqCV" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-c6O7nzqCV text-output csub-heading-c6O7nzqCV none noBorder radius0 none">
<div>
<h2><strong>CURRENCY</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-Vtl1H1PGY" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-Vtl1H1PGY text-output cparagraph-Vtl1H1PGY none noBorder radius0 none">
<div>
<p>5. Except as otherwise provided in this Agreement, all monetary amounts referred to in this Agreement are in USD (US Dollars).</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-C3zlfbcgZ" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-C3zlfbcgZ text-output csub-heading-C3zlfbcgZ none noBorder radius0 none">
<div>
<h2><strong>COMPENSATION</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-WyYtY-IAS" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-WyYtY-IAS text-output cparagraph-WyYtY-IAS none noBorder radius0 none">
<div>
<p><strong>6.</strong> The Contractor will charge the client a flat fee of <strong>$350.00</strong> for portal access and tracking of grant services Services (the "Compensation").</p>
<p>&nbsp;</p>
<p><strong>7.</strong> The Contractor will invoice the Client when the full portal access.</p>
<p>&nbsp;</p>
<p><strong>8.</strong> Invoices submitted by the Contractor to the Client are due upon receipt.</p>
<p>&nbsp;</p>
<p><strong>9.</strong> The Contractor will not be reimbursed for any expenses incurred in connection with providing the Services under this Agreement.</p>
<p>&nbsp;</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-V72eIPNZ2" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-V72eIPNZ2 text-output csub-heading-V72eIPNZ2 none noBorder radius0 none">
<div>
<h2><strong>CONFIDENTIALITY</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-kQFnDX1uP" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-kQFnDX1uP text-output cparagraph-kQFnDX1uP none noBorder radius0 none">
<div>
<p><strong>10.</strong> Confidential information (the "Confidential Information") refers to any data or information relating to the Client, whether business or personal, which would reasonably be considered to be private or proprietary to the Client and that is not generally known and where the release of that Confidential Information could reasonably be expected to cause harm to the Client.</p>
<p>&nbsp;</p>
<p><strong>11</strong>. The Contractor agrees that they will not disclose, divulge, reveal, report or use, for any purpose, any Confidential Information which the Contractor has obtained, except as authorized by the Client or as required by law. The obligations of confidentiality will apply during the Term and will survive indefinitely upon termination of this Agreement.</p>
<p>&nbsp;</p>
<p><strong>12.</strong> All written and oral information and material disclosed or provided by the Client to the Contractor under this Agreement is Confidential Information regardless of whether it was provided before or after the date of this Agreement or how it was provided to the Contractor.</p>
<p>&nbsp;</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-nuPNi9r_b" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-nuPNi9r_b text-output csub-heading-nuPNi9r_b none noBorder radius0 none">
<div>
<h2><strong>OWNERSHIP OF INTELLECTUAL PROPERTY</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-C55u7slOp" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-C55u7slOp text-output cparagraph-C55u7slOp none noBorder radius0 none">
<div>
<p><strong>13</strong>. All intellectual property and related material (the "Intellectual Property") that is developed or produced under this Agreement will be the property of the Contractor. The Client is granted a non-exclusive limited-use license of this Intellectual Property.</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>14.</strong> Title, copyright, intellectual property rights and distribution rights of the Intellectual Property remain exclusively with the Contractor.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-kTSAHBrzk" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-kTSAHBrzk text-output csub-heading-kTSAHBrzk none noBorder radius0 none">
<div>
<h2><strong>RETURN OF PROPERTY</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-_4NChGxW5" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-_4NChGxW5 text-output cparagraph-_4NChGxW5 none noBorder radius0 none">
<div>
<p><strong>15.</strong> Upon the expiration or termination of this Agreement, the Contractor will return to the Client any property, documentation, records, or Confidential Information which is the property of the Client.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-iVuWtaVSU" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-iVuWtaVSU text-output csub-heading-iVuWtaVSU none noBorder radius0 none">
<div>
<h2><strong>CAPACITY/INDEPENDENT CONTRACTOR</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-2hUd_mzVz" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-2hUd_mzVz text-output cparagraph-2hUd_mzVz none noBorder radius0 none">
<div>
<p><strong>16.</strong> In providing the Services under this Agreement it is expressly agreed that the Contractor is acting as an independent contractor and not as an employee. The Contractor and the Client acknowledge that this Agreement does not create a partnership or joint venture between them, and is exclusively a contract for service. The Client is not required to pay, or make any contributions to, any social security, local, state or federal tax, unemployment compensation, workers' compensation, insurance premium, profit-sharing, pension or any other employee benefit for the Contractor during the Term. The Contractor is responsible for paying, and complying with reporting requirements for, all local, state and federal taxes related to payments made to the Contractor under this Agreement.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-Twtv_2TbH" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-Twtv_2TbH text-output csub-heading-Twtv_2TbH none noBorder radius0 none">
<div>
<h2><strong>RIGHT OF SUBSTITUTION</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-Q0vj2w3U_" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-Q0vj2w3U_ text-output cparagraph-Q0vj2w3U_ none noBorder radius0 none">
<div>
<p><strong>17. </strong>Except as otherwise provided in this Agreement, the Contractor may, at the Contractor's absolute discretion, engage a third party sub-contractor to perform some or all of the obligations of the Contractor under this Agreement and the Client will not hire or engage any third parties to assist with the provision of the Services.</p>
<p>-</p>
<p><strong>18.</strong> In the event that the Contractor hires a sub-contractor:</p>
<p>&nbsp;</p>
<p>✔The Contractor will pay the sub-contractor for its services and the Compensation will remain payable by the Client to the</p>
<p>contractor.</p>
<p>&nbsp;</p>
<p>✔For the purposes of the indemnification clause of this Agreement, the sub-contractor is an agent of the Contractor.contractor.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-Ruq5XocbT" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-Ruq5XocbT text-output csub-heading-Ruq5XocbT none noBorder radius0 none">
<div>
<h2><strong>AUTONOMY</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-VlxUesti6" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-VlxUesti6 text-output cparagraph-VlxUesti6 none noBorder radius0 none">
<div>
<p><strong>19.</strong> Except as otherwise provided in this Agreement, the Contractor will have full control over working time, methods, and decision making in relation to provision of the Services in accordance with the Agreement. The Contractor will work autonomously and not at the direction of the Client. However, the Contractor will be responsive to the reasonable needs and concerns of the Client.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-BPXXGx9lH" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-BPXXGx9lH text-output csub-heading-BPXXGx9lH none noBorder radius0 none">
<div>
<h2><strong>EQUIPMENT</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-8_LonhAsI" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-8_LonhAsI text-output cparagraph-8_LonhAsI none noBorder radius0 none">
<div>
<p><strong>20</strong>. Except as otherwise provided in this Agreement, the Contractor will provide at the Contractor &rsquo;s own expense, any and all tools, machinery, equipment, raw materials, supplies, workwear and any other items or parts necessary to deliver the Services in accordance with the Agreement.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-zdnl8xk_m" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-zdnl8xk_m text-output csub-heading-zdnl8xk_m none noBorder radius0 none">
<div>
<h2><strong>NO EXCLUSIVITY</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-ZO1KpLI3h" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-ZO1KpLI3h text-output cparagraph-ZO1KpLI3h none noBorder radius0 none">
<div>
<p><strong>21.</strong> The Parties acknowledge that this Agreement is non-exclusive and that either Party will be free, during and after the Term, to engage or contract with third parties for the provision of services similar to the Services.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-O9nZqmWW5" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-O9nZqmWW5 text-output csub-heading-O9nZqmWW5 none noBorder radius0 none">
<div>
<h2><strong>NOTICE</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-snkDLAREe" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-snkDLAREe text-output cparagraph-snkDLAREe none noBorder radius0 none">
<div>
<p><strong>22</strong>. All notices, requests, demands, or other communications required or permitted by the terms of this agreement will be given through Email and delivered to the Parties at the following Email addresse: <strong>Support@superiorsolutions.com</strong></p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-Euj4y75Hs" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-Euj4y75Hs text-output csub-heading-Euj4y75Hs none noBorder radius0 none">
<div>
<h2><strong>INDEMNIFICATION</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-pqQRS_kN1" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-pqQRS_kN1 text-output cparagraph-pqQRS_kN1 none noBorder radius0 none">
<div>
<p><strong>23.</strong> Except to the extent paid in settlement from any applicable insurance policies, and to the extent permitted by applicable law, each Party agrees to indemnify and hold harmless the other Party, and its respective affiliates, officers, agents, employees, and permitted successors and assigns against any and all claims, losses, damages, liabilities, penalties, punitive damages, expenses, reasonable legal fees and costs of any kind or amount whatsoever, which result from or arise out of any act or omission of the indemnifying party, its respective affiliates, officers, agents, employees, and permitted successors and assigns that occurs in connection with this Agreement. This indemnification will survive the termination of this Agreement.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-9B0oI0puM" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-9B0oI0puM text-output csub-heading-9B0oI0puM none noBorder radius0 none">
<div>
<p><strong>ADDITIONAL CLAUSES</strong></p>
<h2><strong>24. </strong>No Refunds.<strong> </strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-KgmhkJVnc" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-KgmhkJVnc text-output cparagraph-KgmhkJVnc none noBorder radius0 none">
<div>
<p><strong>25</strong>. Grant writing services include:</p>
<p>✔ Grant Searching</p>
<p>✔ {National/Local} Grant applying</p>
<p>✔ Grant data entry (Remember, this is the information you give. (The more informative you are, the better.)</p>
<p>✔ Grant maintaining (upload docs and send requested info needed for approval.) Deadlines of each Grant.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-j3viZnkr3" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-j3viZnkr3 text-output csub-heading-j3viZnkr3 none noBorder radius0 none">
<div>
<h2><strong>MODIFICATION OF THE AGREEMENT</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-u1FT6QRt6" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-u1FT6QRt6 text-output cparagraph-u1FT6QRt6 none noBorder radius0 none">
<div>
<p><strong>26.</strong> Any amendment or modification of this Agreement or additional obligation assumed by either Party in connection with this Agreement will only be binding if evidenced in writing signed by each Party or an authorized representative of each Party.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-T5ezG7FUy" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-T5ezG7FUy text-output csub-heading-T5ezG7FUy none noBorder radius0 none">
<div>
<h2><strong>TIME OF THE ESSENCE</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-FbcvhjDHP" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-FbcvhjDHP text-output cparagraph-FbcvhjDHP none noBorder radius0 none">
<div>
<p><strong>27.</strong> Time is of the essence in this Agreement. No extension or variation of this Agreement will operate as a waiver of this provision.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-81Tv32Le9" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-81Tv32Le9 text-output csub-heading-81Tv32Le9 none noBorder radius0 none">
<div>
<h2><strong>ASSIGNMENT</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-xzQo-Q1ul" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-xzQo-Q1ul text-output cparagraph-xzQo-Q1ul none noBorder radius0 none">
<div>
<p><strong>28. </strong>The Contractor will not voluntarily, or by operation of law, assign or otherwise transfer its obligations under this Agreement without the prior written consent of the Client.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-7RRxqNz9K" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-7RRxqNz9K text-output csub-heading-7RRxqNz9K none noBorder radius0 none">
<div>
<h2><strong>ENTIRE AGREEMENT</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-MKSvDr7jS" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-MKSvDr7jS text-output cparagraph-MKSvDr7jS none noBorder radius0 none">
<div>
<p>It is agreed that there is no representation, warranty, collateral agreement or condition affecting this Agreement except as expressly provided in this Agreement.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-bwCttZpw3" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-bwCttZpw3 text-output csub-heading-bwCttZpw3 none noBorder radius0 none">
<div>
<h2><strong>ENUREMENT</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-6KI3tkw9m" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-6KI3tkw9m text-output cparagraph-6KI3tkw9m none noBorder radius0 none">
<div>
<p><strong>30. </strong>This Agreement will enure to the benefit of and be binding on the Parties and their respective heirs, executors, administrators, and permitted successors and assigns.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-pM_Fe_Mwp" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-pM_Fe_Mwp text-output csub-heading-pM_Fe_Mwp none noBorder radius0 none">
<div>
<h2><strong>TITLES/HEADINGS</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-AZx8fafTt" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-AZx8fafTt text-output cparagraph-AZx8fafTt none noBorder radius0 none">
<div>
<p><strong>31.</strong> Headings are inserted for the convenience of the Parties only and are not to be considered when interpreting this Agreement.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-N7RXonrp5" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-N7RXonrp5 text-output csub-heading-N7RXonrp5 none noBorder radius0 none">
<div>
<h2><strong>GENDER</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-oDoe0lrQe" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-oDoe0lrQe text-output cparagraph-oDoe0lrQe none noBorder radius0 none">
<div>
<p><strong>32.</strong> Words in the singular mean and include the plural and vice versa. Words in the masculine mean and include the feminine and vice versa.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-iuL9fMzXc" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-iuL9fMzXc text-output csub-heading-iuL9fMzXc none noBorder radius0 none">
<div>
<h2><strong>GOVERNING LAW</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-OKCVkaKUf" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-OKCVkaKUf text-output cparagraph-OKCVkaKUf none noBorder radius0 none">
<div>
<p><strong>33.</strong> This Agreement will be governed by and construed in accordance with the laws of the State of Georgia.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-nqurZugby" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-nqurZugby text-output csub-heading-nqurZugby none noBorder radius0 none">
<div>
<h2><strong>SEVERABILITY</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-0vqlz2rOT" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-0vqlz2rOT text-output cparagraph-0vqlz2rOT none noBorder radius0 none">
<div>
<p><strong>34</strong>. In the event that any of the provisions of this Agreement are held to be invalid or unenforceable in whole or in part, all other provisions will nevertheless continue to be valid and enforceable with the invalid or unenforceable parts severed from the remainder of this Agreement.</p>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="sub-heading-gdDoxiIOk" class="c-sub-heading c-wrapper" data-v-0bad29cf="">
<div class="sub-heading-gdDoxiIOk text-output csub-heading-gdDoxiIOk none noBorder radius0 none">
<div>
<h2><strong>WAIVER</strong></h2>
</div>
</div>
</div>
<!--]--><!--[-->
<div id="paragraph-oxuLb7uzY" class="c-paragraph c-wrapper" data-v-0bad29cf="">
<div class="paragraph-oxuLb7uzY text-output cparagraph-oxuLb7uzY none noBorder radius0 none">
<div>
<p><strong>35</strong>. The waiver by either Party of a breach, default, delay or omission of any of the provisions of this Agreement by the other Party will not be construed as a waiver of any subsequent breach of the same or other provisions.</p>
</div>
</div>
</div>
<!--]--><!--]--></div>
</div>
<!--]--><!--]--></div>
</div>
<!--]--><!--]--></div>
</div>
<!--]--><!--]--></div>
</div>
</div>
<!--]--></div>
</div>`,
        previewbg :'',
        otp_phone_input:"",
        otp_email_input:"",
        user_phone:'',
        user_email:'',
        status:0,

        tab: null,
        headers: [

          { text: '', value: 'CompanyURL' },
          { text: '', value: 'CompanyName' },

        ],
        history: [

        ],

        setting: [
        ],

        items: [
              'Admin',
              'Viewer',
      ],
      select_role : 'Admin',
       sectors: [

      ],
      employeeNumber: [
              '10-50',
              '50-100',
              'More than 100',

      ],

      }
    },

    methods: {
    addPhone(){
        this.phoneFlag = 1;
    },
    addEmail(){
        this.emailFlag = 1;
    },
    countryChanged(country) {
        this.country = '+' + country.dialCode
    },
    saveOrder (event) {
      const movedItem = this.users.splice(event.oldIndex, 1)[0];
      this.users.splice(event.newIndex, 0, movedItem);
       axios({
          method: "POST",
           
          url: "/api/save-product-order",
          data : this.users,
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')}
        })
        .then(response => {
            console.log('product order saved');

         })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });
    },
    getAddressData: function (addressData, placeResultData, id) {
            this.company.address_1 = addressData.name;
            this.company.city = addressData.locality;
            this.company.state = addressData.administrative_area_level_1;
            this.company.zip = addressData.postal_code
        },
    uploadLogo(){
      const data = new FormData();
        data.append('file_logo', this.company.logo);
        axios({
          method: "POST",
          url: "/api/upload-logo",
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')},
          data: data
          })
          .then(response => {
          Vue.$toast.success("Logo uploaded", {
              position: 'top-right'
              });
              console.log();
              localStorage.setItem('company_logo',process.env.VUE_APP_WASBI_URL+response.data.data)
          this.loadingUpload = false;

          })
          .catch(err => {
              Vue.$toast.error("Invalid file to upload", {
              position: 'top-right'
              });
              this.isDisableUpload = false;
              this.isDarkUpload = true;
          });
      
    },
    addPromo(){
        this.loadingAssign = true;
        axios({
          method: "POST",
         headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                },
           
          url: "/api/add-promo",
          data: this.product
        })
        
          .then(response => {
              let data = response.data;

              if (response.data) {
                  Vue.$toast.success('Product added successfully', {
                      position: 'top-right'
                      });
                      this.dialogAssign = false;
                      this.loadingAssign = false;
                      this.getProducts();
                      this.product.price = '';
                      this.product.credit = '';
                  }else {
                      Vue.$toast.error(data.message, {
                      position: 'top-right'
                      });
                  }

              })
              .catch(err => {
              Vue.$toast.error('An active promotion code with `code: '+this.promo.name+'` already exists.', {
              position: 'top-right'
              });
              this.loadingAssign = false;
              })
          
            
      },
    uploadLogoBG(){
      const data = new FormData();
        data.append('file_logo', this.company.backgroung_logo);
        axios({
          method: "POST",
          url: "/api/upload-logo-background",
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')},
          data: data
          })
          .then(response => {
          Vue.$toast.success("Logo uploaded", {
              position: 'top-right'
              });
              console.log();
              localStorage.setItem('company_logo_bg',process.env.VUE_APP_WASBI_URL+response.data.data)
          this.loadingUpload = false;

          })
          .catch(err => {
              Vue.$toast.error("Invalid file to upload", {
              position: 'top-right'
              });
              this.isDisableUpload = false;
              this.isDarkUpload = true;
          });
      
    },
    removeLogoBG(){
      if(confirm('Are you sure? you want to remove.')){
        axios({
          method: "POST",
          url: "/api/remove-logo-bg",
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')},
          data: {}
          })
          .then(response => {
          Vue.$toast.success("Logo removed", {
              position: 'top-right'
              });
              localStorage.setItem('company_logo_bg','')
              this.previewbg = ''
          this.loadingUpload = false;

          })
          .catch(err => {
              Vue.$toast.error("Invalid file to upload", {
              position: 'top-right'
              });
              this.isDisableUpload = false;
              this.isDarkUpload = true;
          });
      }
      
    },
    closeDeleteBasic () {
        this.dialogDeleteBasic = false
        this.$nextTick(() => {
          this.editedItemBasic = Object.assign({}, {item:''})
          this.editedIndexBasic = -1
        })
      },
    removeLogo(){
        if(confirm('Are you sure? you want to remove.')){
        axios({
          method: "POST",
          url: "/api/remove-logo",
          headers: {'Content-Type': 'application/json','Cache-Control' : 'no-cache, no-store, must-revalidate',Authorization:"Bearer " + localStorage.getItem('token')},
          data: {}
          })
          .then(response => {
          Vue.$toast.success("Logo removed", {
              position: 'top-right'
              });
              localStorage.setItem('company_logo','')
              this.preview = ''
          this.loadingUpload = false;

          })
          .catch(err => {
              Vue.$toast.error("Invalid file to upload", {
              position: 'top-right'
              });
              this.isDisableUpload = false;
              this.isDarkUpload = true;
          });
        }
      
    },
    verify(){
    let self = this;
    let flag = 1;
    if (!self.email && self.emailFlag ==1) {
    Vue.$toast.error('Email '+this.$t('questionnaire.questionnaire_alert_required'), {
        position: 'top-right'
    });
    this.$refs['email'].focus()
    flag = 0;
    }
    let reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (reg.test(self.email) == false && flag == 1 && self.emailFlag == 1) {
        Vue.$toast.error('Invalid Email format', {
        position: 'top-right'
        });
        this.$refs['email'].focus()
        flag = 0;
    }
    if (!self.phone && flag == 1 && self.phoneFlag == 1) {
    Vue.$toast.error('Phone Number '+this.$t('questionnaire.questionnaire_alert_required'), {
        position: 'top-right'
    });
    this.$refs['phone'].focus()
    flag = 0;
    }

    if (flag == 1) {
    var email = this.email;
    axios({
        method: "POST",
         
        url: "/api/auth/send_otp",
        data: {
        flag : self.phoneFlag == 1 ? 'phone' : 'email',
        email: self.email,
        phone:  self.phone,
        code: self.country,
        logged_flag : 1
        }
    })
        .then(response => {
        let data = response.data;
        if (data.data.flag == 1) {
            if(self.phoneFlag == 1 ){
                self.otp_phone = data.data.otp;
                self.phoneFlag = 2;
            }
            else{
                self.otp_email = data.data.otp;
                self.emailFlag = 2;
            }
            Vue.$toast.success(data.message, {
                position: 'top-right'
            });

        } else {
                Vue.$toast.error(data.message, {
                position: 'top-right'
                });
            }
        })
        .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });
        });
      }
    },
    deleteItemBasic (flag,item) {
        this.editedIndexBasic = this.product.items.indexOf(item)
        this.editedItemBasic = Object.assign({}, item)
        this.dialogDeleteBasic = true
      },
        closeBasic () {
        this.dialog_basic = false
        this.$nextTick(() => {
          this.editedItemBasic = Object.assign({}, {item : ''})
          this.editedIndexBasic = -1
        })
      },
      productEditOpen(item){
      this.product = item
      this.product.items = this.product.items ? Array.isArray(this.product.items) ? this.product.items :JSON.parse(this.product.items) : []
      this.dialogAssign=true
     },
editItemBasic (flag,item) {
        this.editedIndexBasic = this.product.items.indexOf(item)
        this.editedItemBasic = Object.assign({}, item)
        this.dialog_basic = true
      },
        saveBasic (item) {
        if (this.editedIndexBasic > -1) {
          Object.assign(this.product.items[this.editedIndexBasic], this.editedItemBasic)
        } else {
          this.product.items.push(this.editedItemBasic)
        }
        this.closeBasic()
      },
    previewImage: function(event) {
      var input = event.target;
      if (input.files) {
        this.company.logo = input.files[0];
        var reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        }
        this.image=input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    previewImageBG: function(event) {
      var input = event.target;
      console.log(input);
      if (input.files) {
        this.company.backgroung_logo = input.files[0];
        var reader = new FileReader();
        reader.onload = (e) => {
          this.previewbg = e.target.result;
        }
        this.image=input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    verifyOTP(){
        if(this.phoneFlag ==2){
            if(! this.otp_phone_input){
                Vue.$toast.error('OTP '+this.$t('questionnaire.questionnaire_alert_required'), {
                    position: 'top-right'
                });
            }else{
                if(this.otp_phone == this.otp_phone_input){
                    axios({
                        method: "POST",
                         
                        url: "/api/updateprofile",
                        data: {
                            flag: 'phone',
                            phone: this.phone,
                            code: this.country
                        }
                        })
                        .then(response => {
                            let data = response.data;
                            if (data.data == 1) {
                                Vue.$toast.success(data.message, {
                                    position: 'top-right'
                                })
                                this.getUserProfile()
                                this.phoneFlag = 3;
                            } else {
                                Vue.$toast.error(data.message, {
                                position: 'top-right'
                                });
                            }
                        })
                        .catch(err => {
                            Vue.$toast.error(err, {
                            position: 'top-right'
                            });
                        });


                }else{
                    Vue.$toast.error('Invalid OTP', {
                        position: 'top-right'
                    });
                    this.otp_phone_input ="";
                    this.$refs['phone_otp'].focus()
                }
            }

        }else{
            if(! this.otp_email_input){
                Vue.$toast.error('OTP '+this.$t('questionnaire.questionnaire_alert_required'), {
                    position: 'top-right'
                });
            }else{
                if(this.otp_email == this.otp_email_input){
                     axios({
                        method: "POST",
                         
                        url: "/api/updateprofile",
                        data: {
                            flag: 'email',
                            email: this.email,
                        }
                        })
                        .then(response => {
                            let data = response.data;
                            if (data.data == 1) {
                                Vue.$toast.success(data.message, {
                                    position: 'top-right'
                                })
                                //this.$router.push("/home");
                                this.emailFlag = 3;
                                this.getUserProfile()
                            } else {
                                Vue.$toast.error(data.message, {
                                position: 'top-right'
                                });
                            }
                        })
                        .catch(err => {
                            Vue.$toast.error(err, {
                            position: 'top-right'
                            });
                        });

                } else{
                    Vue.$toast.error('Invalid OTP', {
                        position: 'top-right'
                    });
                    this.otp_email_input ="";
                    this.$refs['email_otp'].focus()
                }
            }
        }
    },
      changePassword: function () {
          let flag = 1;
          if (!this.password) {
            Vue.$toast.error('Password '+this.$t('questionnaire.questionnaire_alert_required'), {
                position: 'top-right'
            });
            this.$refs['password'].focus()
            flag = 0;
          }

          if (!this.confpassword) {
            Vue.$toast.error('Confirm Password '+this.$t('questionnaire.questionnaire_alert_required'), {
                position: 'top-right'
            });
            this.$refs['confpassword'].focus()
            flag = 0;
          }
          if (this.confpassword != this.password && flag == 1) {
            Vue.$toast.error('Confirm password did not match', {
                position: 'top-right'
            });
            self.$refs['conf_password'].focus()
            flag = 0;
        }

          if (flag == 1) {

            axios({
            method: "POST",
             
            url: "/api/passwordchange",
            data: {
            password: this.password,
            password_confirmation: this.confpassword,
            logout_other_devices: this.logoutOtherDevices
          }
        })
          .then(response => {
            let data = response.data;
            if (data.data == 1) {
              Vue.$toast.success(this.$t('my_profile.profile_alert_password_change_successfull'), {
                position: 'top-right'
                });

              // If logout other devices is enabled, logout current device as well
              if (this.logoutOtherDevices) {
                Vue.$toast.success('Password changed successfully. Logging out all devices for security...', {
                  position: 'top-right',
                  duration: 3000
                });

                setTimeout(() => {
                  localStorage.removeItem('token');
                  localStorage.removeItem('user_id');
                  localStorage.removeItem('company_id');
                  localStorage.removeItem('company_logo');
                  localStorage.removeItem('company_logo_bg');
                  localStorage.removeItem('email');
                  localStorage.removeItem('role');
                  localStorage.removeItem('name');
                  localStorage.removeItem('is_admin');
                  this.$router.push('/login');
                }, 3000);
              }

            } else {
                Vue.$toast.error(data.message, {
                position: 'top-right'
                });
            }
          })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });
          });
      } else {

      }

    },

    add: function () {
         // for setting tab
    },
    deleteItemConfirmBasic (plan) {
        this.product.items.splice(this.editedIndexBasic, 1)
        this.closeDeleteBasic()
      },
    getUserProfile() {
    let flag = 1;
    let id  = localStorage.getItem('company_id');
    let header = { headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                }
        }
      axios
        .get("/api/get-company/"+id,header)
        .then(response => {
            let data = response.data.data;
            
           if (flag == 1) {
             console.log(data);
                this.company = data
                this.preview = process.env.VUE_APP_WASBI_URL+data.logo
                this.previewbg = process.env.VUE_APP_WASBI_URL+data.logo_background
                if(data.logo)
                  localStorage.setItem('company_logo',process.env.VUE_APP_WASBI_URL+data.logo)
                else
                  localStorage.setItem('company_logo','')
                localStorage.setItem('company_logo_bg',process.env.VUE_APP_WASBI_URL+data.logo_background)
                console.log();
            }else {
                Vue.$toast.error(data.message, {
                position: 'top-right'
                });
            }

         })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });

     },
     getLetters(){
      this.loading = true;
            var offset = (this.page_letter - 1) * 10
            let req = {
              limit : this.limit_letter,
              offset : offset,
              sort : this.datatable_options_letter.sortBy,
              sortDesc : this.datatable_options_letter.sortDesc && this.datatable_options_letter.sortDesc[0] == false ? 'ASC'  :'DESC',
              search : this.search_letter
            }
            axios({
          method: "POST",
           
          url: "/api/get-all-letter",
          data: req,
           header : { headers : {
              Authorization:"Bearer " + localStorage.getItem('token')
              },
            }
        })
            .then(response => {
                
                let data = response.data;

            if (response.data) {
                this.letters = data.data;
                this.pageCountLetter = data.total_page
                this.totalCountLetter = data.count
                this.loading = false;
                }else {
                    Vue.$toast.error(data.message, {
                    position: 'top-right'
                    });
                }

            })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });
    },
    deleteItem(id){
       
       var r = confirm("Are you sure, You went to delete?");
       if (r == true) {
         axios
           .get("/api/delete-promo/"+id,this.header)
           .then(response => {
               let data = response.data;

           if (response.data) {
               Vue.$toast.success('Deleted successfully', {
                   position: 'top-right'
                   });
                 this.getProducts();
               }else {
                   Vue.$toast.error(data.message, {
                   position: 'top-right'
                   });
               }

           })
         .catch(err => {
           Vue.$toast.error(err, {
           position: 'top-right'
           });
         })
       }
     },
    deleteItemLetter(id){
       
       var r = confirm("Are you sure, You went to delete?");
       if (r == true) {
         axios
           .post("/api/delete-letter/"+id,this.header)
           .then(response => {
               let data = response.data;

           if (response.data) {
               Vue.$toast.success('Deleted successfully', {
                   position: 'top-right'
                   });
                 this.getLetters();
               }else {
                   Vue.$toast.error(data.message, {
                   position: 'top-right'
                   });
               }

           })
         .catch(err => {
           Vue.$toast.error(err, {
           position: 'top-right'
           });
         })
       }
     },
     getProducts(){
      this.loading = true;
            this.offset = (this.page - 1) * this.datatable_options.itemsPerPage
            this.selected_project = name;
            let req = {
              limit : this.datatable_options.itemsPerPage,
              offset : this.offset,
              sort : this.datatable_options.sortBy,
              sortDesc : this.datatable_options.sortDesc && this.datatable_options.sortDesc[0] == false ? 'ASC'  :'DESC',
              search : this.search
            }
            axios({
          method: "POST",
           
          url: "/api/get-promo-codes",
          data: req,
           header : { headers : {
              Authorization:"Bearer " + localStorage.getItem('token')
              },
            }
        })
            .then(response => {
                
                let data = response.data;

            if (response.data) {
                this.users = data.data;
                this.pageCount = data.total_page
                this.totalCount = data.count
                this.loading = false;
                }else {
                    Vue.$toast.error(data.message, {
                    position: 'top-right'
                    });
                }

            })
          .catch(err => {
            Vue.$toast.error(err, {
            position: 'top-right'
            });

           });
    },


    saveProfile: function(e) {
      let self = this;
      let flag = 1;
      let id  = localStorage.getItem('company_id');
      let header = { headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                }
        }
        if (!this.company.name) {
            Vue.$toast.error('Name is required', {
                position: 'top-right'
            });
            flag = 0;
        }
        if (!this.company.contact_email && flag == 1) {
            Vue.$toast.error('Contact email is required', {
                position: 'top-right'
            });
            flag = 0;
        }
        if (!this.company.contact_phone && flag == 1) {
            Vue.$toast.error('Contact phone is required', {
                position: 'top-right'
            });
            // this.$refs['username'].focus()
            flag = 0;
        }
        
        if (flag == 1) {
        axios({
          method: "POST",
         headers : {
                Authorization:"Bearer " + localStorage.getItem('token')
                },
           
          url: "/api/edit-company/"+id,
          data: self.company
        })
          .then(response => {
            let data = response.data;
            if (response.data) {
                  Vue.$toast.success('Company edited', {
                    position: 'top-right'
                  })
                  // this.$router.push('/company-profiles')

            } else {
                Vue.$toast.error('Failed To Add', {
                position: 'top-right'
                });
            }
          })
          .catch(err => {
            console.log(err.response);
            
              if(err.response.data.errors.email)
                Vue.$toast.error(err.response.data.errors.email[0], {
                position: 'top-right'
                });
              if(err.response.data.errors.user_name)
                Vue.$toast.error(err.response.data.errors.user_name[0], {
                position: 'top-right'
                });            
          });
        }
    },

 },
 watch: {
  dialogDeleteBasic (val) {
        val || this.closeDeleteBasic()
      },
    searchIcon: function(oldSearchIcon, newSearchIcon) {
    let filteredIcons = [];
    if (this.searchIcon.length === 0) {
      filteredIcons = this.allIcons;
    } else {
      filteredIcons = this.allIcons.filter(i => i.includes(this.searchIcon));
    }
    this.allIcons = filteredIcons;
  },
  datatable_options_letter: {
                handler () {
                this.getLetters()
                },
                deep: true,
            },
            datatable_options: {
                handler () {
                    console.log(this.datatable_options);
                this.getProducts()
                },
                deep: true,
            },
 },
created() {
      console.log('created called.');
      this.getUserProfile();
    },

}
</script>

